import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { BillingPaymentComponent } from 'components/billing-settings'
import ButtonMobileComponent from 'components/button-mobile'
import SwitchComponent from 'components/switch'
import { useState } from 'react'
import { UpdateSchoolInputProps } from 'types/SchoolTypes'
import { GetSubscriptionProps } from 'utils/types'
import SettingsBox from './SettingsBox'
import { titleCase } from 'utils/constants'

interface BillingSettingsProps {
  schoolName: string
  initialSchoolSubscription: GetSubscriptionProps
  onSave: (body: UpdateSchoolInputProps, loadingMsg?: string, cb?: () => void) => Promise<void>
}

function BillingSettings({ schoolName, initialSchoolSubscription, onSave }: BillingSettingsProps) {
  const { billingCycle: initialBillingCycle, paymentMethod: initialPaymentMethod } = initialSchoolSubscription
  const [billingCycle, setBillingCycle] = useState<string | undefined>(initialBillingCycle)
  const [paymentMethodId, setPaymentMethodId] = useState<string | undefined>()
  const [hasChanges, setHasChanges] = useState<boolean>(false)
  const isMonthlySubscription: boolean = billingCycle === 'MONTHLY'

  // Handlers
  const handlePaymentSubmit = (paymentMethodId: string) => {
    setPaymentMethodId(paymentMethodId)
    setHasChanges(true)
  }

  const handleSubscriptionToggle = () => {
    if (billingCycle) {
      setBillingCycle('')
      setHasChanges(true)
    } else {
      setBillingCycle('MONTHLY')
    }
  }

  const isInvalid: boolean = billingCycle === 'MONTHLY' && !paymentMethodId

  const handleSave = async () => {
    if (hasChanges && !isInvalid) {
      const payload: any = {}
      if (billingCycle) {
        payload.schoolSubscription = { billingCycle, paymentMethodId }
      } else {
        payload.schoolSubscription = { billingCycle: '' }
      }
      setHasChanges(false)
      await onSave(payload, 'Updating school subscription...')
    }
  }

  return (
    <SettingsBox title='Billing Settings'>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
        <Typography>
          {billingCycle ? `${titleCase(billingCycle)} school subscription enabled` : 'Enable school subscription'}
        </Typography>
        <SwitchComponent isChecked={!!billingCycle} onChange={handleSubscriptionToggle} />
      </Box>

      {isMonthlySubscription && (
        <BillingPaymentComponent
          name={schoolName}
          paymentMethod={initialPaymentMethod}
          onSubmit={handlePaymentSubmit}
        />
      )}
      {hasChanges && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonMobileComponent text='Save' width='w-[100px]' disabled={isInvalid} onClick={handleSave} />
        </Box>
      )}
    </SettingsBox>
  )
}

export default BillingSettings
